<template>
<div class="qa-card">
    <div class="q-row"><span class="q"></span><div class="q-content">{{q}}</div></div>
    <div class="a-row"><span class="a"></span><div class="a-content">{{a}}</div></div>
    <el-divider></el-divider>
</div>
</template>

<script>

export default {
    props: {
            q: {default: "Question"},
            a: {default: "Answer"},
    },
    data() {
        return {
        }
    },
}
</script>

<style scoped>
.qa-card *, .qa-card *:after, .qa-card *:before {
	-webkit-box-sizing: border-box;
    box-sizing: border-box;
}

.q-row, .a-row{
	display: flex;
	margin-bottom: 10px;
}

.qa-card .q {
	position: relative;
	margin: 0 0 1.5em 0;
}
.qa-card .a {
	position: relative;
	margin: 0 0 2em 0;
	padding: 0 0 1.5em 2em;
}
.qa-card .q::before, .qa-card .a::before {
	font-size: 1.2em;
	margin: 0 0.5em 0 0;
	color: #ffffff;
	border-radius: 50%;
	display: inline-block;
	width: 1.3em;
	height: 1.3em;
	line-height: 1.2em;
}
.qa-card .q::before {
	padding: 0.1em 0.25em;
	content: 'Q';
	background: gray;
}
.qa-card .a::before {
	padding: 0.12em 0.3em;
	content: 'A';
	background: lightsteelblue;
}
</style>